<div class="container">
  <h1 class="title">{{'pool.title'|traduccion}}</h1>

  <button mat-raised-button color="primary" (click)="refresh()"><mat-icon>refresh</mat-icon></button>
  <button mat-raised-button color="primary" (click)="requestPool()">{{'pool.details.action.request'|traduccion}}</button>

  <!-- Tabla de resultados -->
  <div class="table-container">
    <app-data-table
      [dataSource]="dataSource"
      [displayedColumns]="displayedColumns"
      [rowClickable]="true"
      tableClass="mat-elevation-z1"
      (rowClick)="openDetails($event.row)">

      <!-- id -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> {{'pool.table.header.id'|traduccion}} </th>
        <td mat-cell *matCellDef="let element"> {{ element.id }} </td>
      </ng-container>

      <!-- period -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> {{'pool.table.header.status'|traduccion}} </th>
        <td mat-cell *matCellDef="let element"> {{ element.status }} </td>
      </ng-container>

      <!-- maxPeriod -->
      <ng-container matColumnDef="leasedFrom">
        <th mat-header-cell *matHeaderCellDef> {{'pool.table.header.leasedFrom'|traduccion}} </th>
        <td mat-cell *matCellDef="let element"> {{ element.leasedFrom|date:'dd-MM-yyyy HH:mm' }} </td>
      </ng-container>

      <!-- price -->
      <ng-container matColumnDef="leasedUntil">
        <th mat-header-cell *matHeaderCellDef> {{'pool.table.header.leasedUntil'|traduccion}} </th>
        <td mat-cell *matCellDef="let element"> {{ element.leasedUntil|date:'dd-MM-yyyy HH:mm' }} </td>
      </ng-container>

    </app-data-table>
  </div>
</div>
